import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    clientId: Number,
    projectId: Number,
    taskId: Number,
    clientSelectSelector: String,
    projectSelectSelector: String,
    taskSelectSelector: String,
  };

  async select(event) {
    event.preventDefault();

    const clientSelect = document.querySelector(this.clientSelectSelectorValue);
    const projectSelect = document.querySelector(this.projectSelectSelectorValue);
    const taskSelect = document.querySelector(this.taskSelectSelectorValue);

    await this.setSelectValue(clientSelect, this.clientIdValue);
    await this.waitForOptionsLoad(projectSelect);

    await this.setSelectValue(projectSelect, this.projectIdValue);
    await this.waitForOptionsLoad(taskSelect);

    await this.setSelectValue(taskSelect, this.taskIdValue);
  }

  setSelectValue(selectElement, value) {
    return new Promise((resolve) => {
      const tomSelect = selectElement.tomselect;
      if (tomSelect) {
        tomSelect.setValue(value);
      } else {
        selectElement.value = value;
        selectElement.dispatchEvent(new Event('change'));
      }
      resolve();
    });
  }

  waitForOptionsLoad(selectElement) {
    return new Promise((resolve) => {
      const checkOptions = () => {
        const tomSelect = selectElement.tomselect;
        if (tomSelect && Object.keys(tomSelect.options).length > 1) {
          resolve();
        } else {
          setTimeout(checkOptions, 50);
        }
      };
      setTimeout(checkOptions, 100);
    });
  }
}
